import DepartmentPriceVariationChart from '../charts/DepartmentPriceVariationChart';
import EstablishmentPriceVariationChart from '../charts/EstablishmentPriceVariationChart';
import MunicipalityPriceVariationChart from '../charts/MunicipalityPriceVariationChart';

interface ProductPriceAnalyticsTabProps {
  t: (key: string) => string;
}
const ProductPriceAnalyticsTab = ({ t }: ProductPriceAnalyticsTabProps) => {  
  return (
    <div className="tab trend-explorer-tab flex flex-col gap-10 px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">
      {/* <DepartmentPriceVariationChart t={t}/> */}
      {/* <MunicipalityPriceVariationChart t={t}/> */}
      <EstablishmentPriceVariationChart t={t}/>
    </div>
  );
};

export default ProductPriceAnalyticsTab;
